import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { FlexibilityPricesApi } from '../../api/flexibility-prices/flexibility-prices.api';
import { FlexibilityPrices } from '@ps/survey-utils';

@Injectable({ providedIn: 'root' })
export class FlexibilityPricesService {
  private readonly _api = inject(FlexibilityPricesApi);

  public get(surveyId: number): Observable<FlexibilityPrices> {
    return this._api.get(surveyId);
  }
}
